import { Component, EventEmitter, Input, Output,inject,DestroyRef, OnChanges, SimpleChanges, ViewChild, effect } from '@angular/core';
import { ActionService } from 'src/app/shared/services/action/action.service';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { environment } from 'src/environments/environment';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { forkJoin} from 'rxjs';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import * as _ from 'lodash'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ScoreDropdownMenuComponent } from '../../../../shared/components/score/score-dropdown-menu/score-dropdown-menu.component';
import { ScoreWidgetComponent } from '../../../../shared/components/score/score-widget/score-widget.component';
import { NgIf } from '@angular/common';
import { ScoreTableComponent } from '../../../../shared/components/score/score-table/score-table.component';
import { LtmsErrorComponent } from '../../../../shared/components/ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
@Component({
    selector: 'app-action-ageing-actionable-issue-summary',
    templateUrl: './action-ageing-actionable-issue-summary.component.html',
    styleUrls: ['./action-ageing-actionable-issue-summary.component.scss'],
    imports: [ScoreDropdownMenuComponent, ScoreWidgetComponent, NgIf, ScoreTableComponent, LtmsErrorComponent, LtmsLoaderComponent]
})
export class ActionAgeingActionableIssueSummaryComponent implements OnChanges {
  @Input() overallData: any = []
  @Input() overallQuery: any = {}
  @Input() elementId: string = '';
  @Output() onDrilldownChange = new EventEmitter<any>();
  @ViewChild(ScoreWidgetComponent) scoreWidgetComponent!: ScoreWidgetComponent;
  destroyRef = inject(DestroyRef);
  containerId: string = "ltms-hierarchy-table-container"
  viewTypeDropdown: any = {config: {width: '128px', isDisabled: true, tab: 'actionAgeingTable'}, selectedOption: '', options: []};
  leftBoxHeading: string = 'Summary';
  leftBoxDiscription: string = 'Detailed breakdown of open issues by various dimensions, showing total open count, average age, and counts within/missed target TAT.';
  isDataLoaded: boolean = false;
  isHierarchyUpdated: boolean = false;
  fullScreenLeftBox: boolean = false;
  showPercentage: boolean = false;
  timestamp: number = new Date().getTime()
  brandId: string = '';
  fromDate: string = '';
  errorCode: string = '404';
  isDataAvailable: boolean = false;
  newHierarchyStack: any = [];
  lastSelectedFields:any = {};
  toDate: string = '';
  date_filter_type: number = 1;
  rater_type: number = 0;
  project_type: number = 0;
  dropdown: any = {
    groupBy: "category",
    isDefaultSelection: true,
    categorization: true,
    preffix: "By ",
    elementid: 'ltms-dropdown-' + this.timestamp,
    options: []
  }
  mappedQuestions: any = {}
  universalFilter: any = {}
  parent_herarchy: any[] = []
  childData = {
    elementId: "child-summary-" + this.timestamp,
    config: {
      shorting_enabled: true,
    },
    data: [],
    columns: []
  }
  hierarchyStack: any = [];
  hierarchyList: any = [];
  hierarchyListAliasValue: any = [];
  hierarchyMapping: any = {};
  currentHierarchyLevel: any = '';
  currentHierarchyLevelName: any = '';
  requestParameters: any = [];
  drillDownList: any = []
  appliedDrilldownList: any = []
  dateFilterField = _.get(Helpers, 'datePicker.dateFilterType', 1) == 1 ? "feedback_request_date" : "created_date";
  selectedCustomFilter: any = {}

  filterObj: any = {
    currentFilter: {},
    nextFilter: {},
    appliedfilters: [],
    next: {}
  }
  // initial config for new parant datatable 
  distributionTable: any = {
    tablePlugins: {
      isTableResize: true,
    },
    tableHeader: [],
    tableRow: [],
    tableFooter: []
  };
  // initial config for new child/drilldown datatable 
  comapreWithTable: any = {
    tableHeader: [],
    tableRow: [],
    tableFooter: []
  };

  overall: any = {
    elementId: "overall-summary-" + this.timestamp,
    config: {
      shorting_enabled: false,
    },
    data: [],
    columns: []
  }
  brandDetail: any = {}
  apiParameters: any = []
  addOnList: boolean = true
  isBrandDetailLoaded: boolean = false
  isOverallDataLoaded: boolean = false
  childDataCount: number = 0;
  accountDetails: any = {}
  downloadQueryParams: any = {}
  downloadReportOverallHeader: any = [];
  downloadReportDrilldownHeader: any = [];
  exportData: any = []
  questionMapping: any = {};
  group_key_alias:string = ''

  childStaticId = "action-aging-child-summery"
  overallStaticId = "action-aging-overall-summary"
  overAllTableId: string = `${this.overallStaticId}-${this.getTimestamp()}`;
  childTableId: string = `${this.childStaticId}-${this.getTimestamp()}`;
  selectedHierarchy: any = {};
  overallTableData:any= {
    isChildTable: false,
    columns: [],
    rows: []
  }

  drillDownTableData:any= {
    isChildTable: false,
    columns: [],
    rows: []
  }

  scoreWidget(type: string): any {
    return {
      isFullScreenButtonShow: true,
      isDownloadButtonShow: true
    };
  }

  constructor(
    private actionService: ActionService,
    private _analytics: ResponseAnalyticsService,
    private _helpers: HelpersService,
    private _utilsService: UtilsService,
    private _toast: ToastService,
    private appStateService:AppStateService
  ) {
    effect(() => {
      if (this.appStateService.initialized()) {
        let params:any = this.appStateService.appState();
        if (params) {
          this.accountDetails = params.accountDetails;
          this.fromDate = params.datePicker.startDate;
          this.toDate = params.datePicker.endDate;
          // this.selectedHierarchy = params.hierarchyStack;
          this.isHierarchyUpdated = false;
          if (!_.isEqual(params.hierarchyStack, this.selectedHierarchy)) {
            this.selectedHierarchy = params.hierarchyStack
            this.isHierarchyUpdated = true;
          }
          this.universalFilter = params.universalFilter ? params.universalFilter : {};
          let field_id: string = '';
          if (this.selectedHierarchy && this.selectedHierarchy.length) {
            field_id = this.selectedHierarchy[this.selectedHierarchy.length -1].field_id;
          }
          this.group_key_alias = this.actionService.getGroupAliasKey(field_id, params.brandDetails.hierarchy_list_alias)
          if (this.brandId != params.brandDetails._id) {
            this.brandId = params.brandDetails._id;
            this.brandDetail = params.brandDetails
            this.isBrandDetailLoaded = true;
            this.setBrandDetail()
            if (this.isOverallDataLoaded) {
              this.initializeOverall();
              // this.getChildData();
            }
          } else {
            let isExpanded = this.actionService.drilldownTable?.tableRow?.some(item => item.isExpanded);
            if(isExpanded && !this.isHierarchyUpdated){
              this.requestParameters = [];
              this.childDataCount = 0;
              this.comapreWithTable = Helpers.deepClone(this.actionService.drilldownTable);
              this.isDataLoaded = false;
              this.getSelectedDrilldownData()
              const selectedFilter = this.actionService.getSelectedDrilldownFilter()
              if(selectedFilter){
                this.updateFilters(selectedFilter);
              }
            }else{
              this.isDataLoaded = false;
              // this.hierarchyStack = this.newHierarchyStack
              // this.getChildData();
              this.setBrandDetail();
            }          
          }
        }
      }
    });
    // Add event listeners for Escape key and click outside
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }


  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['overallData'] && this.overallData.length) {
      this.isOverallDataLoaded = true
      if (this.isBrandDetailLoaded) {
        this.initializeOverall();
        let isExpanded = this.actionService.drilldownTable?.tableRow?.some(item => item.isExpanded);
        if (!isExpanded) {
          this.getChildData();
        }
      }
    }
  }

  getSelectedDrilldownData(){
    let reqParams = this.getRequestParameters()
    delete reqParams?.field_id;
    delete reqParams?.hierarchy_stack;
    const drilldown_hierarchy = this.actionService.generateApiParams(this.comapreWithTable?.tableRow, reqParams);
    let apiParams: any = drilldown_hierarchy.api_params;
    const filters = drilldown_hierarchy.filters;
    let response: any = {}
    let apiCalls: any = {}
    if(apiParams.length){
      let topLevelParams = Helpers.deepClone(apiParams[0])
      let topLevelParamFieldId = '';
      if (topLevelParams && topLevelParams.field_type == "hierarchy" && topLevelParams.filters && topLevelParams.filters.length) {
        topLevelParamFieldId = topLevelParams.filters[0].field_id
      } else if (this.selectedCustomFilter && this.selectedCustomFilter.field_id) {
        topLevelParamFieldId = this.selectedCustomFilter.field_id
      }
      topLevelParams.field_id = topLevelParamFieldId
      topLevelParams.group_key_alias = this.actionService.getGroupAlias(topLevelParamFieldId)
      delete topLevelParams?.hierarchy_stack;
      apiParams.push(topLevelParams)
      this.requestParameters = apiParams;
      _.forEach(apiParams, (params) => {
        delete params?.filters;
        if (params.field_type == 'tag') {
          params.hierarchy_stack = this.hierarchyStack
        }
        apiCalls[params.field_id] = this.actionService.getComparisonData(params);
      })
      forkJoin(apiCalls).subscribe(allResponses => {
        
        _.forEach(allResponses, (value, key) => {
          let dataMapper:any = {}
          const dataArray = this.processChildData(value, key)

          _.forEach(dataArray, (data) => {
            dataMapper[data.key] = data
          })
          response[key] = dataMapper
        })

        this.updateTableBySelectionHistory(response, Helpers.deepClone(this.comapreWithTable.tableRow))
      })
    }
  }

  updateTableBySelectionHistory(responseData: any[][],tableDataWithCache: any): void {
    this.comapreWithTable.tableRow = this.recursivelyUpdateDrilldown(responseData, tableDataWithCache, 0);
    this.isDataLoaded = true;
  }

  // Process each item in the cached data
  recursivelyUpdateDrilldown(responseData, tableDataWithCache, levelIndex) {
    if (!tableDataWithCache || !tableDataWithCache.length) {
      return tableDataWithCache;
    }

    let fieldId:any = tableDataWithCache[0].field_id;
    if (tableDataWithCache[0].field_type == "hierarchy" && levelIndex == 0) {
      this.comapreWithTable.tableHeader = this.getExportColumns(this.hierarchyMapping[fieldId]);
    }
    let cachedDataMap: any = {}
    let cachedKeys = _.map(tableDataWithCache, (data) => {
      cachedDataMap[data.key] = data
      return data.key
    })

    let newKeys = _.map(responseData[fieldId], (data) => {
      return data.key
    })

    let mergedKeys = [...cachedKeys, ...newKeys]

    mergedKeys = _.uniq(mergedKeys);

    let tableData:any = []

    _.forEach(mergedKeys, (key) => {
      const cachedItem:any = cachedDataMap[key]
      const newData:any = _.get(responseData, fieldId+"."+key);
      let mergedItem:any = {
        ...cachedItem,
        doc_count:  0,
        resolved: 0,
        unresolved: 0,
        within_tat: 0,
        outside_tat:  0,
        actionables:  0
      };

      if (!_.isEmpty(newData)) {
        mergedItem = {
          ...cachedItem, ...newData
        };

        if (cachedItem && cachedItem.field_child) {
          mergedItem.field_child = cachedItem.field_child 
        }

        if (!_.isEmpty(this.lastSelectedFields) && (this.lastSelectedFields.field_id == newData.field_id)) {
          mergedItem.field_child = this.lastSelectedFields.field_child

          if (this.lastSelectedFields.drillDown) {
            mergedItem.drillDown = []
          }
        }

        // Update percentages
        mergedItem.percent = {
          doc_count: this.getPercentage(mergedItem.doc_count, mergedItem.doc_count),
          resolved: this.getPercentage(mergedItem.resolved, mergedItem.doc_count),
          unresolved: this.getPercentage(mergedItem.unresolved, mergedItem.doc_count)
        };

        mergedItem.resolved_with_percentage = mergedItem.resolved + '(' + mergedItem.percent.resolved + '%)';
        mergedItem.unresolved_with_percentage = mergedItem.unresolved + '(' + mergedItem.percent.unresolved + '%)';

        // tableData.push(newData)
      }else {
        // If no new data found for this field_id, set all numeric values to 0
        mergedItem = {
          ...cachedItem,
          doc_count: 0,
          resolved: 0,
          unresolved: 0,
          within_tat: 0,
          outside_tat: 0,
          actionables: 0,
          percent: {
            doc_count: '0.0',
            resolved: '0.0',
            unresolved: '0.0'
          },
          resolved_with_percentage: '0(0.0%)',
          unresolved_with_percentage: '0(0.0%)'
        };
      }

      // Recursively process drilldown data if it exists
      if (cachedItem && cachedItem.drillDown && cachedItem.drillDown.length) {
        // mergedItem.isExpanded = true
        mergedItem.drillDown = this.recursivelyUpdateDrilldown(responseData, cachedItem.drillDown, levelIndex + 1);
      }

      if (cachedItem && cachedItem.field_id) {
        this.lastSelectedFields = {
          'field_id': cachedItem.field_id,
          'field_child': cachedItem.field_child
        }

        if (_.has(cachedItem, 'drillDown')) {
          this.lastSelectedFields['drillDown'] = true
        }
      }

      tableData.push(mergedItem)      

    })

    // while the table retaining if the child table data more than 100 then the data will be download using JOB
    if (tableData && tableData.length >= 100) {
      this.childDataCount = tableData.length
      let params = _.find(this.requestParameters, { "field_id": fieldId });
      this._toast.showPopup('WARN', 'Warning', 'More than 100 results found in the table for the current selection of the filters, sort is unavailable. Please download the data to view the entire range.', 7000);
      const exportQuery = this.prepareDownloadQuery(params);
      this.downloadQueryParams = exportQuery;
    }

    return tableData

    
  }

  onFilterChange(data: any) {
    this.isDataLoaded = false;
    this.exportData = []
    this.appliedDrilldownList = [];
    this.filterObj.appliedfilters = [];
    this.drillDownList = [];
    this.drillDownTableData.rows = [];
    this.viewTypeDropdown.selectedOption = data.name
    this.filterObj.nextFilter = data
    this.selectedCustomFilter = data
    this.comapreWithTable.tableHeader = this.getExportColumns(this.selectedCustomFilter.name);
    this.group_key_alias = this.actionService.getGroupAlias(data.field_id) 
    this.onDrilldownChange.emit({
      filters:this.filterObj.appliedfilters
    })
    
    this.getChildData()
  }

  onViewChange(viewType: any) {
    this.showPercentage = (viewType == 'percent') ? true : false
    this.overall.columns = this.getColumns('Project', 'reset');

    this.appliedDrilldownList = _.map(this.appliedDrilldownList, (object: any) => {
      object.column = this.getColumns(object.data[0].field_name, 'remove')
    })
    const displayName = _.get(this.filterObj, 'nextFilter.name', 'Name')
    this.childData.columns = this.getColumns(displayName, 'add');

    this.overall.elementId = "overall-summary-" + this.getTimestamp();
    this.childData.elementId = "child-summary-" + this.getTimestamp();

  }

  onDownload() {
    if (this.childDataCount < 100) {
      let downloadConfig: any = {
        dataKey: 'uniqueId',
        headerKey: 'header',
        data: [{
          columns: this.downloadReportOverallHeader,
          rows: this.distributionTable.tableRow
        }, {
          columns: this.downloadReportDrilldownHeader,
          rows: this.comapreWithTable.tableRow
        }]
      }
      
      downloadConfig.fileDetails = {
        title: 'Action Summary - Open_Actionables_By_'+ this.selectedCustomFilter.name,
        fileName: 'Action Summary - Open_Actionables_By_'+ this.selectedCustomFilter.name,
        accountName: this.accountDetails.display_name || this.accountDetails.name,
        brandName: this.brandDetail.display_name || this.brandDetail.name
      }

      if (this.questionMapping.questions && this.questionMapping.questions.primary_rating) {
        downloadConfig.fileDetails.interaction = this.questionMapping.questions.primary_rating.text
      }

      if (downloadConfig.data.length) {
        this._analytics.prepareAndDownloadData(downloadConfig);
      }
    } else {
      this.actionService.createDownloadJob(this.downloadQueryParams);
    }
  }

  initializeOverall() {
    this.isOverallDataLoaded = true;
    const overallColumns = this.getExportColumns('Project')
    this.exportData = []
    this.overallTableData.columns = overallColumns;
    this.overallTableData.rows = this.overallData;
    if (this.selectedHierarchy && this.selectedHierarchy.length) {
      // this.distributionTable.tableHeader = this.getExportColumns(this.hierarchyMapping[this.currentHierarchyLevel]);
      this.distributionTable.tableHeader = this.getExportColumns(this.hierarchyMapping[this.selectedHierarchy[0].field_id]);
    } else {
      this.distributionTable.tableHeader = this.getExportColumns('Project');
    }
    // this.distributionTable.tableHeader = this.getExportColumns(this.hierarchyMapping[this.currentHierarchyLevel]);
    this.downloadReportOverallHeader = this.distributionTable.tableHeader;
    this.comapreWithTable.tableHeader = this.getExportColumns(this.selectedCustomFilter['name']);
    this.distributionTable.tableRow = this.overallData;
    this.overAllTableId = `${this.overallStaticId}-${this.getTimestamp()}`;
    // this.prepareDownloadQuery(this.overallData.query)
  }

  prepareDownloadQuery(query: any) {
    let downloadQuery: any = {};
    downloadQuery.brand_id = this.brandId;
    downloadQuery.field_id = this.selectedCustomFilter.field_id;
    downloadQuery.field_type = this.selectedCustomFilter.field_type;
    downloadQuery.api_url = this._utilsService.apiUrlGeneration(environment.actionV1, environment.actionV1.actionStatsComparisonData);
    downloadQuery.question_id = 'primary_rating';
    downloadQuery.parameters = [];
    // downloadQuery.search_possible_values = false;
    downloadQuery.job_name = "action_dashboard_reporting"
    downloadQuery.job_type = 9
    downloadQuery.report_name = 'Action Summary - Open Actionables - ' + this.selectedCustomFilter.name;
    var tabName = "Open Actionables"
    downloadQuery.file_name = 'Action Summary - Open Actionables - ' + this.selectedCustomFilter.name;
    if (_.hasIn(this.filterObj, 'nextFilter.field_id')) {
      downloadQuery.field_id = this.selectedCustomFilter.field_id;
      downloadQuery.field_type = this.selectedCustomFilter.field_type;
    }
    // var universalFilter = Helpers.getUniversalFilter();
    // downloadQuery.parameters.push(Helpers.deepClone(_this.compLeaderboardExportDataQuery.query));
    const index = _.findIndex(this.apiParameters, { "field_id": query.field_id });
    if (index < 0) {
      this.apiParameters.push(query)
    } else {
      this.apiParameters[index] = query
    }
    downloadQuery.parameters = this.apiParameters;
    downloadQuery.search_possible_values = true;
    return downloadQuery
  }

  getExportColumns(display_name?: string) {
    let columns: any = [];
    var name = {
      header: display_name || 'Name',
      dataKey: "name",
      uniqueId: 'name',
      width:'120px',
      isSorting: true,
      isDrilldown: true,
      isClickable: true,
      defaultValue: "",
      order: "1"
    };

    var totalResponse = {
      header: "Issues",
      dataKey: 'actionables',
      defaultValue: 0,
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      uniqueId: 'actionables',
      width:'100px',
      isSorting: true,
      order: "2"
    }

    var open = {
      header: "Open",
      dataKey: 'unresolved',
      uniqueId: 'unresolved',
      width:'100px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      defaultValue: 0,
      order: "3"
    }
    var closed = {
      header: "Solved",
      dataKey: 'resolved',
      uniqueId: 'resolved',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      order: "4"
    }
    var distColumn = {
      dataKey: "tat_distribution",
      header: "Issue Distribution",
      uniqueId: 'tat_distribution',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      order: "5"
    };

    var averageTAT = {
      header: "Average Age(hrs)",
      dataKey: 'age',
      uniqueId: 'age',
      width:'145px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      defaultValue: 0,
      order: "6"
    }
    var withinTAT = {
      header: "Within TAT",
      dataKey: 'within_tat_with_percentage',
      uniqueId: 'within_tat_with_percentage',
      width:'120px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      defaultValue: 0,
      order: "7"
    }
    var missedTAT = {
      header: "Missed TAT",
      dataKey: 'outside_tat_with_percentage',
      uniqueId: 'outside_tat_with_percentage',
      width:'120px',
      style: {
        row: "flex-end",
        header: "flex-end"
      },
      isSorting: true,
      defaultValue: 0,
      order: "8"
    }
    columns = [name, totalResponse, open, averageTAT, withinTAT, missedTAT]
    return columns
  }

  getExportColumnsForReport(display_name?: string) {
    let columns: any = [];
    var name = {
      header: display_name || 'Name',
      dataKey: "name",
      uniqueId: 'name',
      width:'120px',
      isSorting: true,
      isDrilldown: true,
      isClickable: true,
      defaultValue: "",
      order: "1"
    };

    var totalResponse = {
      header: "Issues",
      dataKey: 'actionables',
      defaultValue: 0,
      uniqueId: 'actionables',
      width:'100px',
      isSorting: true,
      order: "2"
    }

    var open = {
      header: "Open",
      dataKey: 'unresolved',
      uniqueId: 'unresolved',
      width:'100px',
      isSorting: true,
      defaultValue: 0,
      order: "3"
    }

    var averageTAT = {
      header: "Average Age(hrs)",
      dataKey: 'age',
      uniqueId: 'age',
      width:'145px',
      isSorting: true,
      defaultValue: 0,
      order: "4"
    }
    var withinTAT = {
      header: "Within TAT",
      dataKey: 'within_tat',
      uniqueId: 'within_tat',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      order: "5"
    }
    var missedTAT = {
      header: "Missed TAT",
      dataKey: 'outside_tat',
      uniqueId: 'outside_tat',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      order: "6"
    }
    var withinTATPercent = {
      header: "Within TAT %",
      dataKey: 'percent.within_tat',
      uniqueId: 'percent.within_tat',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      order: "7"
    }
    var missedTATPercent = {
      header: "Missed TAT %",
      dataKey: 'percent.outside_tat',
      uniqueId: 'percent.outside_tat',
      width:'120px',
      isSorting: true,
      defaultValue: 0,
      order: "8"
    }
    columns = [name, totalResponse, open, averageTAT, withinTAT, missedTAT, withinTATPercent, missedTATPercent]
    return columns
  }

  initDropdownOptions(options: any) {
    if (!_.isEmpty(options)) {
      // this.group_key_alias = 'brands'
      this.selectedCustomFilter = options[0]
      this.filterObj.nextFilter = this.selectedCustomFilter
      this.viewTypeDropdown.config.isDisabled = false;
      this.viewTypeDropdown.selectedOption = options[0].name
      this.viewTypeDropdown.options = options      
      this.dropdown.options = options
      this.dropdown.elementid = 'ltms-dropdown-' + new Date().getTime()
    } else {
      this.viewTypeDropdown.config.isDisabled = true;      
    }
  }

  setBrandDetail(): void {
    this.rater_type = _.get(this.brandDetail, 'main_rater_type');
    this.project_type = _.get(this.brandDetail, 'project_type');
    this.questionMapping = this.actionService.configureActionService(this.brandDetail)
    const dropdownDetails = this.actionService.prepareViewTypeDropdown(this.brandDetail, this.selectedHierarchy);
    var options: any = dropdownDetails.options;
    this.hierarchyMapping = dropdownDetails.hierarchyMapping
    this.currentHierarchyLevel = dropdownDetails.currentHierarchyLevel 
    this.initDropdownOptions(options)
    // this.initializeOverall()
    this.drillDownTableData.rows = [];
    this.isDataLoaded = false
    this.filterObj.appliedfilters = [];
    this.getChildData();
    this.onDrilldownChange.emit({
        filters: this.filterObj.appliedfilters
    })
  }
  getTimestamp() {
    return new Date().getTime();
  }
  
  getChildData(event?:any) {
    // this.isDataLoaded = false;
    let displayName: any = ''
    if (event && event.field_type == 'tag') {
      displayName = this.actionService.filterNameMap[this.filterObj.nextFilter.field_id].name
    } else {
      displayName = _.get(this.filterObj, 'nextFilter.name', 'Name')
    }
    // const displayName = _.get(this.filterObj, 'nextFilter.name', 'Name')
    const fieldId = _.get(this.filterObj, 'nextFilter.field', '')
    let params = this.getRequestParameters()
    params.group_key_alias = this.group_key_alias
    this.actionService.getComparisonData(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (responseObject) => {
        if (responseObject) {
          let rowData:any = [];
          const columns = this.getExportColumns(displayName);
          let rows = this.processChildData(responseObject)
          this.prepareDownloadQuery(this.overallQuery)
          // rowData.push({
          //   name: columns[0].header,
          // })
          // const processedData = this.getMappedData(responseObject, columns);
          // this.distributionTable.tableRow = this.overallData.data;
          const index = _.findIndex(this.exportData, { "field_id": 'overall' });
          if (index < 0) {
            this.exportData.push({
              field_id: 'overall',
              order: this.exportData.length,
              columns: this.getExportColumnsForReport(this.hierarchyMapping[this.currentHierarchyLevel]),
              rows: this.overallData
            })
            this.downloadReportOverallHeader = this.getExportColumnsForReport(this.hierarchyMapping[this.currentHierarchyLevel])
          } else {
            this.exportData[index] = {
              field_id: 'overall',
              order: this.exportData.length,
              columns: this.getExportColumnsForReport(this.hierarchyMapping[this.currentHierarchyLevel]),
              rows: this.overallData
            }
          }
  
          this.childData.data = this.processChildData(responseObject);
          this.childData.columns = this.getColumns(displayName, 'add');
          this.childData.elementId = "child-summary-" + this.getTimestamp();
  
          this.exportData.push({
            field_id: fieldId,
            order: this.exportData.length,
            columns: this.getExportColumnsForReport(displayName),
            rows: this.childData.data
          })

          if (rows && rows.length) {
            _.each(rows, row=>{
              rowData.push(row)
            })
          }

          if (event && event.drillDown) {
            event.drillDown = rowData;
            event.columns = columns
            event.header =  this.getExportColumnsForReport(displayName)
            this.actionService.getInitializedTable(this.comapreWithTable)
          }else {
            this.comapreWithTable.tableRow = rows
            this.downloadReportDrilldownHeader = this.getExportColumnsForReport(displayName)
          }


          if(rows && rows.length >= 100){
            // sorting button is hiding incase of more than 100 rows
            this.comapreWithTable.tableHeader = _.map(this.comapreWithTable.tableHeader, column=>{
              column.isSorting = false;
              return column;
            })
            this._toast.showPopup('WARN', 'Warning', 'More than 100 results found in the table for the current selection of the filters, sort is unavailable. Please download the data to view the entire range.', 7000);
            const exportQuery= this.prepareDownloadQuery(params);
            this.downloadQueryParams = exportQuery;
          }
          
          let data: any = _.get(responseObject.data, 'RatingsSummary', {});
          if (!_.isEmpty(data)) {
            this.isDataAvailable = true;
          } else {
            this.isDataAvailable = false;
          }
          this.isDataLoaded = true;
        }
        else {
          this.isDataAvailable = false;
          this.isDataLoaded = true;
        }
      },
      error: (err) => {
        this.isDataAvailable = false;
        this.isDataLoaded = true;
        if (err.status == '500') {
          this.errorCode = '500'
        } else if (err.status == "404") {
          this.errorCode = '404'
        } else if (err.status == "408") {
          this.errorCode = '408'
        }
      }
    })
  }

  getMappedData(response: any, columns: any) {
    let list = _.get(this.drillDownTableData, 'rows', []);
    const childData: any = this.processChildData(response);
    if (!_.isEmpty(list)) {
      this.drillDownTableData.rows = this.mapChildData(list, columns, childData)
    } else {
      this.drillDownTableData.columns = columns
      this.drillDownTableData.rows = childData
    }
    
    this.childTableId = `${this.childStaticId}-${this.getTimestamp()}`;
  }

  mapChildData(list: any, columns: any, childData: any) {
    return _.map(list, (object: any) => {
      if (object.field_id == this.selectedHierarchy[0].field_id && object.name == this.selectedHierarchy[0].name) {
        object.child = {
          isChildTable: true,
          columns: columns,
          rows: childData
        }
      } else if (_.hasIn(object, 'child.rows') && !_.isEmpty(object.child.rows)) {
        const rows = _.get(object, 'child.rows', [])
        object.child.rows = this.mapChildData(rows, columns, childData)
      }
      return object;
    })
  }


  onDrillDown(data?: any, eventType?: string) {
    if(data.isExpanded){
      this.actionService.getInitializedTable(this.comapreWithTable)
    }
    this.updateFilters(data, eventType);
  }

  updateFilters(data?: any, eventType?: string) {
    this.actionService.setDrilldownFilters(data);
    this.actionService.setSelectedDrilldownFilter(data)

    this.apiParameters = this.apiParameters.splice(this.apiParameters.length - 1, 1)
    // this.filterObj.appliedfilters = this.actionService.clone(data.filters);
    if (data.filters) {
      this.filterObj.appliedfilters = JSON.parse(JSON.stringify(data.filters));
    }
    // Set data as current filter that
    this.filterObj.currentFilter = this.actionService.clone(data);
    if (this.addOnList) {
      this.exportData.push({
        field_id: data.field_id,
        order: this.exportData.length,
        columns: this.getExportColumnsForReport(data.field_name),
        rows: [data]
      })
    }


    if (data.field_type == 'hierarchy') {
      this.filterObj.nextFilter = this.actionService.getNextHierarchy(this.filterObj.currentFilter.field_id)
      this.selectedCustomFilter = this.filterObj.nextFilter
    } else if (data.field_type == 'touchpoint') {
      this.filterObj.nextFilter = {};
    } else if (data.field_type == 'tag' || data.field_type == 'response') {
      if (data.field_child && !_.isEmpty(data.field_child)) {
        this.filterObj.nextFilter = JSON.parse(JSON.stringify(data.field_child));
        // If field type is response then set it as type and change type of question to sub_type
        if (this.filterObj.nextFilter.field_type && this.filterObj.nextFilter.field_type == 'response') {

          if (this.filterObj.nextFilter.type == "multi-select") {
            this.filterObj.nextFilter = this.actionService.getPrpsAndPossibleValuesForMultiSelect(this.filterObj.nextFilter);
          }

          this.filterObj.nextFilter.field_sub_type = JSON.parse(JSON.stringify(this.filterObj.nextFilter.type));
          this.filterObj.nextFilter.type = 'response';
        } else {
          this.filterObj.nextFilter.type = 'tag';
        }
      } else {
        this.filterObj.nextFilter = {};
      }
    }

    let applyFilterObj = {
      field_id: data.field_id,
      field_type: data.field_type,
      field_sub_type: data.field_sub_type,
      field_value: data.name,
      group_key : [data.name],
      field_data_type: data.field_data_type
    }

    if (applyFilterObj.field_type == 'response') {
      if (!isNaN(applyFilterObj.field_value)) {
        applyFilterObj.field_value = parseInt(applyFilterObj.field_value);
      }
      if (applyFilterObj.field_sub_type == 'multi-select') {
        _.each(this.filterObj.currentFilter.field_possible_values, function (obj: any) {
          if (obj.value == applyFilterObj.field_value) {
            applyFilterObj.field_id = obj.field_id;
          }
        });
      }
    }

    const currentLevel = parseInt(applyFilterObj.field_id.split('_')[2]);
    
    this.filterObj.appliedfilters = this.filterObj.appliedfilters.filter(filter => {
      const filterLevel = parseInt(filter.field_id.split('_')[2]);
      return filterLevel < currentLevel;
    });

    this.filterObj.appliedfilters.push(applyFilterObj);

    if (data.field_id != 'touchpoint') {
      this.group_key_alias = data.field_id
      this.onDrilldownChange.emit({
        filters:this.filterObj.appliedfilters,
        groupKeyAlias:this.group_key_alias
      })

      // while collapse the drilldown row prevent to call child data api
      if ((!_.has(data, 'isExpanded') || data.isExpanded == false) && eventType == 'drilldown') {
        this.getChildData(data)
      }
    }

  }

  removeDrillDown(data: any) {
    if (data.field_id != 'touchpoint') {
      this.group_key_alias = data.field_id
      const index = _.findIndex(this.appliedDrilldownList, { field_id: data.field_id })
      this.appliedDrilldownList.splice(index + 1, this.appliedDrilldownList.length)
      this.filterObj.appliedfilters.splice(index + 1, this.filterObj.appliedfilters.length)

      const exportDataIndex = _.findIndex(this.exportData, { field_id: data.field_id })
      this.exportData.splice(exportDataIndex + 1, this.exportData.length)

      const exportQueryIndex = _.findIndex(this.apiParameters, { field_id: data.field_id })
      this.apiParameters.splice(exportQueryIndex + 1, this.apiParameters.length)

      this.filterObj.currentFilter = data
      if (data.field_type == "hierarchy") {
        this.filterObj.nextFilter = this.actionService.getNextHierarchy(data.field_id)
      } else {
        this.filterObj.nextFilter = this.selectedCustomFilter
      }
      this.onDrilldownChange.emit({
        filters:this.filterObj,
        groupKeyAlias:this.group_key_alias
      })
      this.getChildData()
    }
  }

  resetHierarchData() {
    this.appliedDrilldownList = [];
    this.filterObj.appliedfilters = [];
    this.drillDownList = [];
    this.addOnList = true
    let selectedFilter = this.viewTypeDropdown?.options.find(item => item.name === this.viewTypeDropdown?.selectedOption)
    this.onFilterChange(selectedFilter)
    this.filterObj.nextFilter = this.dropdown.options[0];
    this.group_key_alias = this.actionService.getGroupAlias(this.selectedCustomFilter.field_id)
    const exportDataIndex = _.findIndex(this.exportData, { field_id: 'overall' })
    this.exportData.splice(exportDataIndex + 1, this.exportData.length)

    const exportQueryIndex = _.findIndex(this.apiParameters,{ field_id: 'overall' })
    this.apiParameters.splice(exportQueryIndex + 1, this.apiParameters.length)

    this.onDrilldownChange.emit({
      filters:this.filterObj,
      groupKeyAlias:this.group_key_alias
    })
    this.getChildData()
  }

  getRequestParameters() {
    var params: any = {}
    var raterType = (this.brandDetail && this.brandDetail.main_rater_type) ? this.brandDetail.main_rater_type : null;
    var sortBy = 'average_rating';
    if (raterType == 3 || raterType == 10) {
      sortBy = 'nps_score';
    }
    params = this.actionService.getInitialQueryParameters();
    if (this.selectedHierarchy && this.selectedHierarchy.length) {
      params.hierarchy_stack = this.selectedHierarchy;
    }
    if (_.hasIn(this.filterObj, 'appliedfilters') && this.filterObj.appliedfilters.length) {
      params.filters = this.filterObj.appliedfilters;
    }
    params.main_rater_type = raterType
    params.universal_filter = this.universalFilter;
    params.from = this.fromDate
    params.to = this.toDate
    params.brand_id = this.brandId;
    params.action_type = 'ageing';
    params.view_type = 'list';
    params.field_id = this.filterObj.nextFilter.field_id;
    params.field_type = this.selectedCustomFilter.field_type || "hierarchy";
    params.question_aggs = true;
    params.is_custom_date_range_selected = true;

    if (this.selectedCustomFilter.data_type && this.selectedCustomFilter.data_type == "range" && this.selectedCustomFilter.possible_values && this.selectedCustomFilter.possible_values.length) {
      params.field_data_type = this.selectedCustomFilter.data_type;
      params.possible_values = this.selectedCustomFilter.possible_values;
    }

    if (this.selectedCustomFilter.field_type && this.selectedCustomFilter.field_type == "response" && this.selectedCustomFilter.possible_values && this.selectedCustomFilter.possible_values.length) {
      params.field_type = "response";
      if (this.selectedCustomFilter.type == "multi-select") {
        // this.selectedCustomFilter = getPossibleValuesForMultiSelect(this.selectedCustomFilter);
      }
      params.possible_values = this.selectedCustomFilter.possible_values;
      params.field_sub_type = this.selectedCustomFilter.type;
    }

    // // If filter object is available then it will take data from that
    if (this.filterObj && this.filterObj.appliedfilters && this.filterObj.appliedfilters.length) {
      // Set filters object if it is available. 
      params.filters = this.filterObj.appliedfilters;
    }
    params.actionable_filter = _.get(this.brandDetail, "action_management_configuration.actionables", {});
    params.age_type = _.get(this.brandDetail, "action_management_configuration.ageing_config.type", 1);
    params.turnaround = _.get(this.brandDetail, "action_management_configuration.ageing_config.turnaround_time", 0);
    params.date_field = this.dateFilterField || 'created_date';
    return params
  }

  processChildData(response: any, field_id?:any) {
    const closedStatus:any = this.actionService.getClosedStatus()
    let summary: any = _.get(response.data, 'age', {});
    let retingSummary: any = _.get(response.data, 'RatingsSummary', {})
    let hierarchy: any = _.get(response.data, 'hierarchyMap', {})
    let list: any = []
    this.childDataCount = 0;
    if (!_.isEmpty(retingSummary)) {
      _.each(retingSummary, (object: any, key: string) => {
        const statusDistribution:any = _.get(retingSummary,key+".status_distribution",{})
        object.name = hierarchy[key]||key;
        object.key = this.filterObj.nextFilter.field_id + '_' + object.name;
        object.within_tat = 0;
        object.outside_tat = 0
        if (!_.isEmpty(summary) && summary[key]) {
          object.doc_count = summary[key].within_tat + summary[key].outside_tat;
          object.within_tat = summary[key].within_tat;
          object.outside_tat = summary[key].outside_tat;
          object.age = summary[key].age
        } else {
          object.doc_count = object.within_tat + object.outside_tat;
          object.within_tat = object.within_tat
          object.outside_tat = object.outside_tat
        }
        object.percent = {
          doc_count: this.getPercentage(object.doc_count, object.doc_count),
          within_tat: this.getPercentage(object.within_tat, object.doc_count),
          outside_tat: this.getPercentage(object.outside_tat, object.doc_count)
        }
        object.within_tat_with_percentage = object.within_tat + '(' + object.percent.within_tat + '%)'
        object.outside_tat_with_percentage = object.outside_tat + '(' + object.percent.outside_tat + '%)'
        object.age = Math.round(object.age);
        object.resolved = 0
        object.unresolved = 0
        object.field_id = this.filterObj.nextFilter.field_id;
        object.level_name = this.filterObj.nextFilter.name;
        object.field_type = this.filterObj.nextFilter.type || this.filterObj.nextFilter.field_type;
        object.isChildExists = !this.actionService.isEndOfHierarchy(this.filterObj.nextFilter.field_id);
        if ((object.isChildExists == true && object.field_type == 'hierarchy') || (this.filterObj.nextFilter?.child && this.filterObj.nextFilter.child.field_id)) {
          object.drillDown = []
        }
        // object.filters = this.actionService.clone(this.filterObj.appliedfilters);
        object.filters = JSON.parse(JSON.stringify(this.filterObj?.appliedfilters));
        object = this.processDrilldownData(object)
        if (!_.isEmpty(field_id)) {
          object.field_id = field_id
          object.key = field_id + '_' + object.name;
          object.level_name = Helpers.hierarchyMapping[field_id]
          object.field_name = Helpers.hierarchyMapping[field_id]
          object.isChildExists = !this.actionService.isEndOfHierarchy(field_id);
          if ((object.isChildExists == true && object.field_type == 'hierarchy') || (this.filterObj.nextFilter?.child && this.filterObj.nextFilter.child.field_id)) {
            object.drillDown = []
          }
        }
        _.each(statusDistribution,(count:number,uuid:string)=>{
          if(_.includes(closedStatus, uuid)){
            object.resolved = object.resolved + count
          }else{
            object.unresolved = object.unresolved + count
          }
        })
        this.childDataCount += 1;
        list.push(object)
      })
    }
    if (this.childDataCount > 100) {
      list.splice(100, this.childDataCount);      
    }
    return list;
  }

  getPercentage(count: number, total: number) {
    let percentage: any = '';
    percentage = (((count / total) * 100)).toFixed(1);
    if (percentage >= 0) {
      return percentage;
    } else {
      return '0.0'
    }
  }


  processDrilldownData(data: any) {
    if (this.filterObj && this.filterObj.nextFilter && this.filterObj.nextFilter.field_id) {
      data.field_id = this.filterObj.nextFilter.field_id;
      data.field_name = this.filterObj.nextFilter.name;
      data.field_type = this.filterObj.nextFilter.type || this.filterObj.nextFilter.field_type;
      data.field_sub_type = this.filterObj.nextFilter.field_sub_type;
      data.field_data_type = this.filterObj.nextFilter.data_type;
      data.field_possible_values = this.filterObj.nextFilter.possible_values;
      data.field_child = this.filterObj.nextFilter.child;
    } else if (this.filterObj && this.filterObj.currentFilter && this.filterObj.currentFilter.field_id) {
      data.field_id = this.filterObj.currentFilter.field_id;
      data.field_name = this.filterObj.currentFilter.field_name;
      data.field_type = this.filterObj.currentFilter.field_type || this.filterObj.currentFilter.type;
      data.field_sub_type = this.filterObj.currentFilter.field_sub_type;
      data.field_data_type = this.filterObj.currentFilter.field_data_type || this.filterObj.currentFilter.data_type;
      data.field_possible_values = this.filterObj.currentFilter.field_possible_values || this.filterObj.currentFilter.possible_values;
      data.field_child = this.filterObj.currentFilter.field_child || this.filterObj.currentFilter.child;
    } else if (this.selectedCustomFilter) {
      if (this.selectedCustomFilter.field_type && this.selectedCustomFilter.field_type == 'response') {
        data.field_type = this.selectedCustomFilter.field_type;
        data.field_sub_type = this.selectedCustomFilter.type;
      } else {
        data.field_type = this.selectedCustomFilter.type;
      }
      data.field_id = this.selectedCustomFilter.field_id;
      data.field_name = this.selectedCustomFilter.name;
      data.field_data_type = this.selectedCustomFilter.data_type;
      data.field_possible_values = this.selectedCustomFilter.possible_values;
      data.field_child = this.selectedCustomFilter.child;
    }
    return data
  }

  getColumns(display_name?: string, eventType?: string) {
    let columns: any = [];
    var isDeviationEnabled = !Helpers.isCustomDateRangeSelected;

    var name = {
      field: "name",
      name: display_name || 'Name',
      order: "1",
      width: "20%",
      ellipsis_width: '201',
      type: 'text',
      is_custom_style: true,
      clickable: true,
      event: (data: any) => {
        if (eventType == 'remove') {
          this.removeDrillDown(data)
        }
        if (eventType == 'add') {
          this.onDrillDown(data)
        }
        if (eventType == 'reset') {
          this.resetHierarchData()
        }
      }
    };

    var totalResponse = {
      field: 'actionables',
      name: "Issues",
      type: 'number',
      is_deviation_enabled: isDeviationEnabled,
      width: "14%",
      order: "2"
    }

    var open = {
      field: 'unresolved',
      name: "Open",
      type: 'number',
      is_deviation_enabled: isDeviationEnabled,
      width: "14%",
      order: "3"
    }

    var distColumn = {
      field: "tat_distribution",
      name: "Issue Distribution",
      type: 'component',
      dont_allow_sort: true,
      customClass: "toggle-table-column",
      width: "18%",
      order: "5"
    };

    var closed = {
      field: 'resolved',
      name: "Solved",
      type: 'number',
      is_deviation_enabled: isDeviationEnabled,
      width: "14%",
      order: "4"
    }
    var averageTAT = {
      field: 'age',
      name: "Avg. Age(hrs)",
      type: 'number',
      is_deviation_enabled: isDeviationEnabled,
      width: "19%",
      order: "4"
    }
    var withinTAT = {
      field: 'within_tat',
      name: "Within TAT",
      type: 'number',
      is_deviation_enabled: isDeviationEnabled,
      width: "19%",
      order: "4"
    }
    var missedTAT = {
      field: 'outside_tat',
      name: "Missed TAT",
      type: 'number',
      is_deviation_enabled: isDeviationEnabled,
      width: "19%",
      order: "4"
    }
    columns = [name, totalResponse, open, averageTAT, withinTAT, missedTAT]
    return columns
  }


  onFullscreenLeftBox(event, cardName): void {
    this.fullScreenLeftBox = event;
  }

  // Method to handle Escape key press
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.fullScreenLeftBox) {
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  // Method to handle clicks outside the content
  handleClickOutside(event: MouseEvent) {
    const overlayElements = document.getElementsByClassName('fullscreen'); // Get all elements with the overlay class
    const contentElements = document.getElementsByClassName('ageing-hierarchy-table'); // Get all elements with the content class

    // Check if the clicked element is the overlay
    const isOverlayClick = Array.from(overlayElements).some(overlay => overlay.contains(event.target as Node));
    const isContentClick = Array.from(contentElements).some(content => content.contains(event.target as Node));

    if (this.fullScreenLeftBox && isOverlayClick && !isContentClick) { // Only exit fullscreen if the overlay is clicked
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  ngOnDestroy(): void {
    // Remove event listeners and reset
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }
}
